// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__35Fs6"};